<template>
  <div>
    <CrudList
      title="Comodidades"
      storeName="Amenities"
      labelAddNew="Añadir nueva comodidad"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      sortable
      next-link="/admin/provinces"
      :breadcrumbs="[
        {
          text: 'Spots y vehículos',
          disabled: false,
          href: '/admin/amenities'
        },
        {
          text: 'Comodidades',
          disabled: false,
          href: '#'
        }
      ]"
    >
      <template v-slot:icon_picture="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-list-item-avatar v-if="item.icon_picture">
              <img :src="item.icon_picture" alt="" />
            </v-list-item-avatar>
          </v-col>
        </v-row>
      </template>
      <template v-slot:description="{ item }">
        <div class="table-cell-fixed description-cell">
          {{ item.description }}
        </div>
      </template>
    </CrudList>
  </div>
</template>
<style>
.table-cell-fixed {
  min-height: 100px; /* altura mínima */
  max-height: 100px; /* altura fija */
  display: flex;
  align-items: center;
  overflow: hidden; /* evita desbordes */
}

.description-cell {
  font-size: 12px;       /* más pequeña */
  line-height: 1.2;      /* compacto */
  overflow-y: auto;      /* scroll si es muy larga */
  max-height: 100%;      /* respeta altura fija */
}
</style>
<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
  data: () => ({
    offsetTop: 0
  }),
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    }
  }
};
</script>
